<template lang="pug">
v-app

  v-app-bar(app dense flat clipped-left)
    img.mr-1.ml-3(:src="$vuetify.theme.dark ? '/static/logo-black.png' : '/static/logo-white.png'" height="40")

  v-main(flat)
    v-container(fill-height style="max-width: 350px")
      v-container
        v-row(justify="center" no-gutters)
          v-col.mb-8(align="center")
            v-img(:src="$vuetify.theme.dark ? imageUrl.dark : imageUrl.light" width="70%")
          v-col.mb-8(cols="12" align="center")
            h1.headline {{ $t("вход_в_рмни") }}
          v-col(cols="12")
            v-form(ref="form" @submit.prevent="signIn()")
              v-text-field(
                ref="number"
                v-model="number"
                :label="$t('введите_заводской_или_регистрационный_номер_кассы')"
                :disabled="signInLoading"
                @input="numberError = null"
                :error-messages="numberError"
                outlined
                autocomplete="off")
              v-text-field(
                ref="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                :label="$t('введите_пароль')"
                :disabled="signInLoading"
                @input="passwordError = null"
                :error-messages="passwordError"
                outlined
                autocomplete="off"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword")
              v-btn(block color="primary" type="submit" :loading="signInLoading" @click.prevent="signIn()") {{ $t("авторизоваться") }}
              v-row.mt-5(justify="center")
                span.caption {{ $t("продолжая_вы_соглашаетесь_с") }}
                a.caption.ml-1(@click="$openLink('https://static.rekassa.kz/ru/app/3.0/agreement/agreement.pdf', '_system')") {{ $t("условиями_использования") }}

        v-row.mt-8(justify="center" no-gutters)
          v-col(cols="4")
            v-row(justify="center" no-gutters)
              a.caption(@click="changeLocale('ru')" :class="{ 'font-weight-bold' : locale === 'ru' }") Русский
          v-col(cols="4" justify="center")
            v-row(justify="center" no-gutters)
              a.caption(@click="changeLocale('kk')" :class="{ 'font-weight-bold' : locale === 'kk' }") Қазақша

  re-connection-warning
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale, changeLocale } from '../../i18n'
import ConnectionWarning from '../utils/ConnectionWarning.vue'

export default {
  components: {
    're-connection-warning': ConnectionWarning,
  },

  data: () => ({
    imageUrl: {
      dark: '/static/illustrations/rally/dark/undraw_security_o890.svg',
      light: '/static/illustrations/rally/light/undraw_security_o890.svg',
    },

    number: '',
    password: '',

    numberError: null,
    passwordError: null,

    showPassword: false,
    signInLoading: false,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),

    locale() {
      return getLocale()
    },
  },

  created() {
    if (this.user) {
      this.$router.push('/')
    }
  },

  methods: {
    ...mapActions({
      signInBySerialNumber: 'auth/signInBySerialNumber',
      signInWithCustomToken: 'auth/signInWithCustomToken',
      setUser: 'auth/setUser',
      init: 'cashRegisters/init',
      showSnackbar: 'tools/showSnackbar',
    }),

    signIn() {
      if (this.number.length > 0 && this.password.length > 0) {
        this.signInLoading = true
        const params = new URLSearchParams()
        params.append('number', this.number)
        params.append('password', this.password)
        this.signInBySerialNumber(params).then((serialNumberResult) => {
          this.signInWithCustomToken({ token: serialNumberResult.data }).then((tokenResult) => {
            this.setUser(tokenResult.user).then(() => {
              this.init().then(() => {
                this.$router.push('/', () => {})
              })
            })
          }).catch((error) => {
            this.signInLoading = false
            this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
          })
        }).catch(() => {
          this.signInLoading = false
          this.numberError = this.$t('не_найден')
          this.passwordError = this.$t('не_найден')
          this.showSnackbar({ message: this.$t('неверный_заводской_серийный_номер_или_пароль') })
        })
      } else {
        if (this.number.length === 0) {
          this.numberError = this.$t('требуется_заполнить')
        }
        if (this.password.length === 0) {
          this.passwordError = this.$t('требуется_заполнить')
        }
      }
    },

    changeLocale(locale) {
      changeLocale(locale)
    },
  },
}
</script>
<style lang="stylus">
</style>
